import PlateAppearanceResult from "../../enums/PlateAppearanceResult.js";

const classifiesAsBattedBallEvent = function(paResult) {
    switch (paResult) {
        case PlateAppearanceResult.Double.key:
        case PlateAppearanceResult.FieldOut.key:
        case PlateAppearanceResult.FieldersChoice.key:
        case PlateAppearanceResult.FoulOut.key:
        case PlateAppearanceResult.FoulTipOut.key:
        case PlateAppearanceResult.GroundRuleDouble.key:
        case PlateAppearanceResult.HomeRun.key:
        case PlateAppearanceResult.InfieldFly.key:
        case PlateAppearanceResult.InsideTheParkHomeRun.key:
        case PlateAppearanceResult.ReachedOnError.key:
        case PlateAppearanceResult.SacrificeBunt.key:
        case PlateAppearanceResult.SacrificeFly.key:
        case PlateAppearanceResult.SacrificeOnError.key:
        case PlateAppearanceResult.SacrificeOnFieldersChoice.key:
        case PlateAppearanceResult.SacrificePlay.key:
        case PlateAppearanceResult.Single.key:
        case PlateAppearanceResult.Triple.key:
        //case PlateAppearanceResult.Unidentified.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsBattedBallEvent;